const React = require('react');
const helper = require('../../../helper/dish-helper');
const classnames = require('classnames');

require('./dish-detail-head.scss');

module.exports = React.createClass({
  displayName: 'DishDetailHead',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    onCountChange: React.PropTypes.func.isRequired,
    minimum: React.PropTypes.number,
    shouldInitCount: React.PropTypes.bool,
    showMemberPriceInfo: React.PropTypes.bool,
  },
  componentDidMount() {
    const { dish, shouldInitCount } = this.props;
    if (shouldInitCount) {
      this.props.onCountChange(dish.dishIncreaseUnit);
    }
  },
  onCountChange(newCount, increament) {
    this.props.onCountChange(increament);
  },
  splitPropsSpecifications(dish) {
    /*
    if (dish.sameDishIndexs) {
      return false;
    }

    if (!helper.isSingleDishWithoutProps(dish) && dish.dishPropertyTypeInfos) {
      const specification = [];
      dish.dishPropertyTypeInfos.map(
        dishProperty => {
          if (dishProperty.type === 4) {
            specification.push(dishProperty.properties[0].name);
          }
          return false;
        }
      );
      return specification.length !== 0 ? '(' + specification.join(',') + ')' : false;
    }
    */
    /*
    return dish.spec;
    */
    return false;
  },
  render() {
    const { dish, showMemberPriceInfo } = this.props;
    const { order, isMember } = dish;
    let price = dish.marketPrice;
    let totalMemberPrice = 0;
    // 仅仅显示一份菜品的价格
    if (Array.isArray(order) && order.length) {
      const newDish = dish.setIn(['order', '0', 'count'], 1);
      price = helper.getDishPrice(newDish);
      totalMemberPrice += helper.getTotalMemberPrice(newDish);
    } else if (typeof order === 'number') {
      totalMemberPrice += helper.getTotalMemberPrice(dish);
    }

    const isShowMemberPrice = isMember && showMemberPriceInfo && totalMemberPrice >= 0;

    /* /{dish.unitName} */
    const unitName = dish.unitName === '份' ? '' : '/' + dish.unitName;
    return (
      <div className="dish-detail-head o-flex__fixed">
        <div className="head-main">
          <p className="dish-name">
            {dish.name}
            {this.splitPropsSpecifications(dish)}
            {unitName}
            <span>&nbsp;</span>
            {!dish.isVirtualDish && isShowMemberPrice > 0 && <span className="price">{parseFloat(totalMemberPrice)}</span>}
            {!dish.isVirtualDish && <span className={classnames('price', { 'line-price': isShowMemberPrice > 0 })}>{parseFloat(price)}</span>}
          </p>
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/dish-detail-head.jsx